<template>
  <div class="loading" v-if="visible">
    <span class="loader icon-load" v-if="icon=='refresh'" style="display:inline-block;width:18px;height:18px;">
      <Icon type="load-c" size='18' ></Icon>
    </span>
    <span v-else><Icon :type="icon"></Icon></span>
     {{text}}
  </div>
</template>

<script>

export default {
  name: 'Loading',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    icon: {
      default: 'refresh'
    },
    text: {
      default: '正在加载,请稍等...'
    }
  },
  data () {
    return {
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .icon-load{
    animation: ani-spin 1s linear infinite;
  }
  @keyframes ani-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .loading{
    text-align: center;
    padding: 20px;
  }
</style>
